/**
 * Container that shifts its size depending on sidebar(s) being open
 *
 */
import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {connect} from 'react-redux';

import dimensions from '@app/styles/dimensions';

const Container = ({
  bottom,
  children,
  className,
  dataQe,
  left,
  leftSidebarOpen,
  position,
  right,
  rightSidebarOpen,
  top,
  width,
  sx,
  ...props
}) => {
  const styles = useMemo(
    () => ({
      transition: theme =>
        theme.transitions.create(['margin-left', 'margin-right', 'width'], {
          easing:
            leftSidebarOpen || rightSidebarOpen
              ? theme.transitions.easing.easeOut
              : theme.transitions.easing.sharp,
          duration:
            leftSidebarOpen || rightSidebarOpen
              ? theme.transitions.duration.enteringScreen
              : theme.transitions.duration.leavingScreen,
        }),
      marginRight:
        (rightSidebarOpen && !leftSidebarOpen) ||
        (rightSidebarOpen && leftSidebarOpen)
          ? `${dimensions.rightSidebar.width}px`
          : 0,
      marginLeft:
        (leftSidebarOpen && !rightSidebarOpen) ||
        (rightSidebarOpen && leftSidebarOpen)
          ? `${dimensions.leftSidebar.width}px`
          : 0,
    }),
    [leftSidebarOpen, rightSidebarOpen]
  );

  return (
    <Box
      data-testid={dataQe}
      {...props}
      sx={[
        {
          bottom: bottom,
          left: left,
          position: position,
          right: right,
          top: top,
          width: width,
          ...sx,
          ...styles,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {children}
    </Box>
  );
};
Container.propTypes = {
  bottom: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.func,
  ]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataQe: PropTypes.string,
  left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  leftSidebarOpen: PropTypes.bool.isRequired,
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'sticky', null]),
  right: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rightSidebarOpen: PropTypes.bool.isRequired,
  sx: PropTypes.object,
  top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const mapStateToProps = state => ({
  leftSidebarOpen: state.ui.drawers.left !== '',
  rightSidebarOpen: state.ui.drawers.right !== '',
});

export default connect(mapStateToProps, {})(Container);
